export default __webpack_public_path__ + "static/Chiro Elite-d01e7ab52158bd86ba5d90bbaacce1c4.jpg";